module.exports = __webpack_public_path__ + "img/xuanze.69ad185f.png";